"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDatepickerInputButton = exports.StyledDatepickerInputWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledDatepickerInputWrapper = styled_components_1.default.div(function (_a) {
    var colors = _a.theme.colors;
    return "\n    position: relative;\n\n    svg path {\n      fill: ".concat(colors.primary, ";\n    }\n");
});
exports.StyledDatepickerInputButton = styled_components_1.default.button(function (_a) {
    var _b = _a.theme, space = _b.space, focusRing = _b.focusRing, radii = _b.radii;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: none;\n    text-align: left;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n\n    &:focus-visible {\n      ", "\n    }\n  "], ["\n    background: none;\n    text-align: left;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n\n    &:focus-visible {\n      ", "\n    }\n  "])), space[12], space[12], radii.standard, radii.standard, (0, styled_components_1.css)(focusRing));
});
var templateObject_1;
